// src/components/titlebar/components/ViewMenu.tsx

import React from "react"
import { Menu, MenuItem } from "@mui/material"
import { Visibility as ViewIcon, ZoomIn as ZoomInIcon, ZoomOut as ZoomOutIcon, ZoomOutMap as ResetZoomIcon } from "@mui/icons-material"
import { ViewMenuButton, menuPaperStyle } from "../styles/titleBarStyles"
import type { ViewMenuProps } from "../types/titleBarTypes"

const ViewMenu: React.FC<ViewMenuProps> = ({
  anchorEl,
  isDevelopmentMode,
  onOpen,
  onClose,
  onReload,
  onForceReload,
  onToggleDevTools,
  onResetZoom,
  onZoomIn,
  onZoomOut,
  onToggleFullscreen,
}) => {
  return (
    <>
      <ViewMenuButton startIcon={<ViewIcon sx={{ fontSize: 14 }} />} onClick={onOpen}>
        보기
      </ViewMenuButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: menuPaperStyle,
        }}
      >
        <MenuItem onClick={onReload}>새로고침</MenuItem>
        <MenuItem onClick={onForceReload}>강제 새로고침</MenuItem>
        {isDevelopmentMode && [
          <MenuItem key="dev-tools" onClick={onToggleDevTools}>
            개발자 도구
          </MenuItem>,
        ]}
        <MenuItem divider />
        <MenuItem onClick={onResetZoom}>
          <ResetZoomIcon sx={{ mr: 1, fontSize: 16 }} />
          원래 크기
        </MenuItem>
        <MenuItem onClick={onZoomIn}>
          <ZoomInIcon sx={{ mr: 1, fontSize: 16 }} />
          확대
        </MenuItem>
        <MenuItem onClick={onZoomOut}>
          <ZoomOutIcon sx={{ mr: 1, fontSize: 16 }} />
          축소
        </MenuItem>
        <MenuItem divider />
        <MenuItem onClick={onToggleFullscreen}>전체화면</MenuItem>
      </Menu>
    </>
  )
}

export default ViewMenu
